import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import { SaveResourceLibraryRequest, ISaveResourceLibraryRequest } from "services/KnowfullyAdminClient";

import ResourceLibraryForm from "./ResourceLibraryForm";

type ResourceLibraryCreateFormProps = {
  onResourceLibraryCreated: (createdResourceLibrary: ISaveResourceLibraryRequest) => void;
  onCancel: () => void;
};

const ResourceLibraryCreateForm = ({
  onResourceLibraryCreated,
  onCancel,
}: ResourceLibraryCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: ISaveResourceLibraryRequest) => {
    return registerPromise(
      resourceLibraryService.saveResourceLibrary(new SaveResourceLibraryRequest(values))
    )
      .then((createdResourceLibrary) => {
        onResourceLibraryCreated(createdResourceLibrary);
      })
      .catch((err: any) => {
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryForm
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryFormCreateButton" })}
      onCancel={onCancel}
    />
  );
};

export default ResourceLibraryCreateForm;
